import type { SyncEntity } from './syncTypes';
import { isCustomerAppendOnlySyncPayload } from './customerSyncOperationId';

/** Mostrador / kit: pueden encolar sin red. */
const KIT_OFFLINE_QUEUE_ENTITIES: ReadonlySet<SyncEntity> = new Set([
  'sale',
  'sale_void',
  'cash_session',
  'cash_outflow',
  'cash_outflow_void',
]);

export function isStockFromSalePayload(payload: Record<string, unknown>): boolean {
  const reason = typeof payload.reason === 'string' ? payload.reason.trim() : '';
  if (reason.startsWith('sale:')) return true;

  const referenceType = typeof payload.referenceType === 'string' ? payload.referenceType.trim() : '';
  if (referenceType === 'sale') return true;

  const sourceContext = typeof payload.sourceContext === 'string' ? payload.sourceContext.trim() : '';
  if (sourceContext === 'sale') return true;

  return false;
}

/**
 * ¿Puede esta entidad+payload ir a cola local sin red?
 * Oleada 5: solo mostrador + customer de venta + stock pegado a venta.
 */
export function canQueueEntityOffline(entity: SyncEntity, payload: Record<string, unknown>): boolean {
  if (KIT_OFFLINE_QUEUE_ENTITIES.has(entity)) return true;

  if (entity === 'fiado') {
    return isCustomerAppendOnlySyncPayload(payload);
  }

  if (
    entity === 'stock_adjustment' ||
    entity === 'stock_lot' ||
    entity === 'stock_lot_allocation'
  ) {
    return isStockFromSalePayload(payload);
  }

  return false;
}

export function isOnlineOnlyEntity(entity: SyncEntity, payload: Record<string, unknown>): boolean {
  return !canQueueEntityOffline(entity, payload);
}
